// Import Libraries
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// -----------------------------------------------------------
//  PrismProductIncompleteWarning
// -----------------------------------------------------------
const PrismProductIncompleteWarning = (props, { projectsMustBeFinished }) => {
  const text = (() => {
    if (projectsMustBeFinished) {
      return "You haven't filled all available image slots. Please complete the product before placing the order.";
    }

    return "You haven't filled all available image slots. Are you sure you want to place your order?";
  })();

  const cssClasses = [
    'alert',
    projectsMustBeFinished ? 'alert-danger' : 'alert-warning',
  ];

  return (
    <div
      className={classNames(cssClasses)}
      role="alert"
      data-test-id="just-added-item-warning">
      <strong>Note:&nbsp;</strong>
      {text}
    </div>
  );
};
PrismProductIncompleteWarning.displayName = 'PrismProductIncompleteWarning';
PrismProductIncompleteWarning.contextTypes = {
  projectsMustBeFinished: PropTypes.bool,
};

export default PrismProductIncompleteWarning;
